module.exports = __webpack_public_path__ + "static/img/zhu.a945752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhu.jpg
// module id = GiSJ
// module chunks = 1